import React, {useEffect, useContext} from 'react'
import { Dropdown } from 'semantic-ui-react'
import { GrownupsContext } from "../../../GrownupsContext";

import "./SelectFonts.css"

const SelectFontsDropdown = (props) => {
    const options = [
        "'Lato', sans-serif",
        "'Dancing Script', cursive",
        "'Abril Fatface', cursive",
        "'Amatic SC', cursive",
        "'Righteous', cursive",
        "'Sacramento', cursive",
        "'Indie Flower', cursive",
        "'Pacifico', cursive",
        "'Scope One', serif",
        "'Merriweather', serif",
        "'Roboto Slab', serif",
        "'Rubik', sans-serif",
        "'Montserrat', sans-serif",
    ].map((font,i) => ({
        key: i,
        text: props.example,
        value: font,
        content: (
          <div style={{fontSize: '15px', fontFamily: font}}>{props.example}</div>
        )
    }));

    return (
    <Dropdown
        selection
        fluid
        options={options}
        placeholder={props.name}
        value={props.font}
        onChange={props.handleChange}
        style={{
            fontSize: '15px',
            fontFamily: props.font,
            backgroundColor: 'var(--color-scheme-fonts-background)',
            color: 'var(--color-scheme-fonts)'
        }}
     />);
    }

export const applyAppFonts = (fonts) => {
    document.documentElement.style.setProperty('--font-title', fonts['Title']);
    document.documentElement.style.setProperty('--font-list-title', fonts['My Task List']);
    document.documentElement.style.setProperty('--font-task', fonts['My Task']);
}

export const SelectFonts = () => {
    const {fonts, setFonts} = useContext(GrownupsContext);

    useEffect(()=>{
        applyAppFonts(fonts);
    }, [fonts])

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
            {
                 Object.keys(fonts).map(key =>
                    <SelectFontsDropdown key={key} name={key} example={key} font={fonts[key]}
                            handleChange={(e, { value }) => {
                                const c = structuredClone(fonts);
                                c[key] = value;
                                setFonts(c)
                            }
                            }/>
                 )
            }
        </div>
    );
}
